import { render } from "./BaseButton.vue?vue&type=template&id=72c9a16c&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=72c9a16c&scoped=true&lang=css"

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c9a16c"]])

export default __exports__